import React from 'react';
import {connect} from 'react-redux';
import UberEatsWinnersListWidget from './Widgets/WinnersList';

const UberEatsWinners = props => (
  <div id="ue-winners">
    <header className="content-header">
      <h1>
        Winners
        <small> GOAT Uber Eats</small>
      </h1>
    </header>
    <section className="content">
      <UberEatsWinnersListWidget />
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UberEatsWinners);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Winners/index.tsx